module.exports = __webpack_public_path__ + "static/casual-fridays-logo-transparent-0d7832db9da25fff3ef59d969f7c054a.png";